module.exports = {
  validation: {
    login: {
      email: {
        required: "admin.sign_in_email_required",
        pattern: "admin.sign_in_email_invalid",
      },
      password: {
        required: "admin.sign_in_password_required",
      },
    },
    forgot_password: {
      email: {
        required: "admin.forgot_password_email_required",
        pattern: "admin.forgot_password_email_invalid",
      },
    },
    otp_verification: {
      otp: {
        required: "admin.otp_verification_otp_required",
        pattern: "admin.otp_verification_otp_invalid",
      },
    },
    reset_password: {
      new_password: {
        required: "admin.reset_password_password_required",
        pattern: "admin.reset_password_password_invalid",
      },
      confirm_password: {
        required: "admin.reset_password_confirm_password_invalid",
        same_password: "admin.reset_password_confirm_password_same_invalid",
      },
    },
    translation: {
      key: {
        required: "admin.translation_key_required",
        min_length: "admin.translation_key_min_length",
        max_length: "admin.translation_key_max_length",
      },
      title: {
        required: "admin.translation_title_required",
        min_length: "admin.translation_title_min_length",
        max_length: "admin.translation_title_max_length",
      },
      translations: {
        min_items: "admin.translation_min_items_required",
      },
    },
    edit_profile: {
      first_name: {
        required: "admin.edit_profile_first_name_required",
        max_length: "admin.edit_profile_first_name_max_length",
        invalid_format: "admin.edit_profile_first_name_invalid_format",
      },
      email: {
        invalid_format: "admin.edit_profile_email_invalid_format",
        max_length: "admin.edit_profile_email_max_length",
      },
      contact_number: {
        min_length: "admin.edit_profile_contact_number_min_length",
        max_length: "admin.edit_profile_contact_number_max_length",
      },
    },
    settings: {
      header_logo_required: "admin.settings_header_logo_required",
      email_logo_required: "admin.settings_email_logo_required",
      favicon_logo_required: "admin.settings_favicon_logo_required",
      login_page_logo_required: "admin.settings_login_page_logo_required",
      ios_version_required: "admin.settings_ios_version_required",
      android_version_required: "admin.settings_android_version_required",
      contact_email_required: "admin.settings_contact_email_required",
      invalid_email_format: "admin.settings_invalid_email_format",
      invalid_file_format: "admin.settings_invalid_file_format",
      invalid_version_format: "admin.settings_invalid_version_format",
      version_max_length: "admin.settings_version_max_length",
      version_numbers_only: "admin.settings_version_numbers_only",
      premium_grant_months_invalid: "admin.settings_premium_grant_months_invalid",
      premium_grant_months_required: "admin.settings_premium_grant_months_required",
      premium_grant_months_integer: "admin.settings_premium_grant_months_integer",
      premium_grant_months_min: "admin.settings_premium_grant_months_min",
      premium_auto_grant_invalid_combo: "admin.settings_premium_auto_grant_invalid_combo",
    },
    referralSettings: {
      milestone_size_invalid: "admin.referral_settings_milestone_size_invalid",
      milestone_size_required: "admin.referral_settings_milestone_size_required",
      milestone_size_integer: "admin.referral_settings_milestone_size_integer",
      milestone_size_min: "admin.referral_settings_milestone_size_min",
      milestone_size_max: "admin.referral_settings_milestone_size_max",
      months_per_milestone_invalid: "admin.referral_settings_months_per_milestone_invalid",
      months_per_milestone_required: "admin.referral_settings_months_per_milestone_required",
      months_per_milestone_integer: "admin.referral_settings_months_per_milestone_integer",
      months_per_milestone_min: "admin.referral_settings_months_per_milestone_min",
      months_per_milestone_max: "admin.referral_settings_months_per_milestone_max",
      consecutive_days_invalid: "admin.referral_settings_consecutive_days_invalid",
      consecutive_days_required: "admin.referral_settings_consecutive_days_required",
      consecutive_days_integer: "admin.referral_settings_consecutive_days_integer",
      consecutive_days_min: "admin.referral_settings_consecutive_days_min",
      consecutive_days_max: "admin.referral_settings_consecutive_days_max",
      min_messages_invalid: "admin.referral_settings_min_messages_invalid",
      min_messages_required: "admin.referral_settings_min_messages_required",
      min_messages_integer: "admin.referral_settings_min_messages_integer",
      min_messages_min: "admin.referral_settings_min_messages_min",
      min_messages_max: "admin.referral_settings_min_messages_max",
      reward_plan_required: "admin.referral_settings_reward_plan_required",
    },
    deactivate_user: {
      reason: {
        required: "admin.deactivate_user_reason_required",
        min_length: "admin.deactivate_user_reason_min_length",
        max_length: "admin.deactivate_user_reason_max_length",
      },
    },
    cms: {
      slug: {
        required: "admin.cms_slug_required",
        pattern: "admin.cms_slug_pattern",
        max_length: "admin.cms_slug_max_length",
      },
      title: {
        required: "admin.cms_title_required",
        max_length: "admin.cms_title_max_length",
      },
      content: {
        required: "admin.cms_content_required",
      },
      seo_meta_title: {
        max_length: "admin.cms_seo_meta_title_max_length",
      },
      seo_meta_desc: {
        max_length: "admin.cms_seo_meta_desc_max_length",
      },
    },
    emailTemplate: {
      slug: {
        required: "admin.email_template_slug_required",
        min_length: "admin.email_template_slug_min_length",
        max_length: "admin.email_template_slug_max_length",
        invalid: "admin.email_template_slug_invalid",
      },
      title: {
        required: "admin.email_template_title_required",
        min_length: "admin.email_template_title_min_length",
        max_length: "admin.email_template_title_max_length",
      },
      subject: {
        required: "admin.email_template_subject_required",
        min_length: "admin.email_template_subject_min_length",
        max_length: "admin.email_template_subject_max_length",
      },
      content: {
        required: "admin.email_template_content_required",
        min_length: "admin.email_template_content_min_length",
      },
      language: {
        required: "admin.email_template_language_required",
        invalid: "admin.email_template_language_invalid",
      },
      templates: {
        required: "admin.email_template_templates_required",
        min_items: "admin.email_template_at_least_one_template",
      },
    },
    smsTemplate: {
      slug: {
        required: "admin.sms_template_slug_required",
        min_length: "admin.sms_template_slug_min_length",
        max_length: "admin.sms_template_slug_max_length",
        invalid: "admin.sms_template_slug_invalid",
      },
      title: {
        required: "admin.sms_template_title_required",
        min_length: "admin.sms_template_title_min_length",
        max_length: "admin.sms_template_title_max_length",
      },
      content: {
        required: "admin.sms_template_content_required",
        min_length: "admin.sms_template_content_min_length",
      },
      language: {
        required: "admin.sms_template_language_required",
        invalid: "admin.sms_template_language_invalid",
      },
      templates: {
        required: "admin.sms_template_templates_required",
        min_items: "admin.sms_template_at_least_one_template",
      },
    },
  },
};
